import { React, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { InterviewService } from "../../../../services/InterviewService";
import { OtherDocumentLine } from "./OtherDocumentLine";

export function OtherDocuments({ interviewId, updateDocumentsGrid, disabled }) {
  const { t } = useTranslation();
  const [otherDocuments, setOtherDocuments] = useState([]);
  const [isAccordionCollapsed, setIsAccordionCollapsed] = useState(true);

  useEffect(() => {
    getOtehrDocuments();
  }, [updateDocumentsGrid]);

  function getOtehrDocuments() {
    if (interviewId > 0) {
      InterviewService.getOtherDocuments(Number(interviewId)).then((docs) => {
        if (docs !== undefined && docs.length > 0) {
          setOtherDocuments(docs);
        } else {
          setOtherDocuments([]);
        }
      });
    }
  }

  return (
    <>
      {((disabled && otherDocuments.length > 0) || !disabled) && (
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingCvs">
            {!disabled ? (
              <button
                className={`accordion-button ${
                  isAccordionCollapsed && otherDocuments.length === 0
                    ? "collapsed"
                    : isAccordionCollapsed && otherDocuments.length > 0
                    ? ""
                    : !isAccordionCollapsed && otherDocuments.length > 0
                    ? "collapsed"
                    : isAccordionCollapsed
                    ? "collapsed"
                    : ""
                }`}
                type="button"
                data-bs-target="#collapseCvs"
                aria-expanded="true"
                aria-controls="collapseCvs"
                onClick={() => setIsAccordionCollapsed(!isAccordionCollapsed)}
              >
                {t("Others")}
              </button>
            ) : (
              <label className={"accordion-button label-documents"}>
                {t("Others")}
              </label>
            )}
          </h2>
          {!disabled ? (
            <div
              id="collapseCvs"
              className={`accordion-collapse ${
                isAccordionCollapsed && otherDocuments.length === 0
                  ? "collapse"
                  : isAccordionCollapsed && otherDocuments.length > 0
                  ? ""
                  : !isAccordionCollapsed && otherDocuments.length > 0
                  ? "collapse"
                  : isAccordionCollapsed
                  ? "collapse"
                  : ""
              }`}
              aria-labelledby="headingCvs"
              data-bs-parent="#accordionFlushDocuments"
            >
              <div class="accordion-body table-wrap documents-tab-cv margim-table-documents">
                <table className="table mt-2">
                  <thead>
                    <th className="languages">{t("Language")}</th>
                    <th className="description">{t("Description")}</th>
                    <th className="updated-date">{t("Updated on")}</th>
                    <th className="actions">{t("Actions")}</th>
                  </thead>
                  <tbody>
                    <OtherDocumentLine
                      docs={otherDocuments}
                      interviewId={interviewId}
                      deleteCallBack={getOtehrDocuments}
                      disabled={disabled}
                    />
                  </tbody>
                </table>
              </div>
            </div>
          ) : (
            <div
              id="collapseCvs"
              className="accordion-collapse"
              aria-labelledby="headingCvs"
              data-bs-parent="#accordionFlushDocuments"
            >
              <div class="accordion-body table-wrap documents-tab-cv margim-table-documents">
                <table className="table mt-2">
                  <thead>
                    <th className="languages">{t("Language")}</th>
                    <th className="description">{t("Description")}</th>
                    <th className="updated-date">{t("Updated on")}</th>
                    <th className="actions">{t("Actions")}</th>
                  </thead>
                  <tbody>
                    <OtherDocumentLine
                      docs={otherDocuments}
                      interviewId={interviewId}
                      deleteCallBack={getOtehrDocuments}
                      disabled={disabled}
                    />
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </div>
      )}
    </>
  );
}
